'use strict';

import appModule from '../../app.module';

angular.module(appModule)
.controller('AdminAutorisationsMinieresController', ['$scope', '$http', '$timeout', function($scope, $http, $timeout) {

  var API = '/api/autorisations-minieres';

  var rawList = [];
  var allList = [];
  $scope.autorisations = [];
  $scope.isLoading     = true;
  $scope.showModal     = false;
  $scope.saving        = false;
  $scope.currentPage   = 1;
  $scope.itemsPerPage  = 10;
  $scope.totalItems    = 0;
  $scope.totalPages    = 0;
  $scope.searchQuery   = '';
  $scope.filterType    = '';
  $scope.filterStatut  = '';
  $scope.editingItem   = {};
  $scope.successMsg    = '';
  $scope.errorMsg      = '';

  // ── Pagination ────────────────────────────────────────────────────────────
  function paginate() {
    var size = parseInt($scope.itemsPerPage, 10);
    if (!size) {
      $scope.autorisations = allList;
      $scope.totalPages    = 1;
    } else {
      var start = ($scope.currentPage - 1) * size;
      $scope.autorisations = allList.slice(start, start + size);
      $scope.totalPages    = Math.ceil(allList.length / size) || 1;
    }
  }

  $scope.changePageSize = function() { $scope.currentPage = 1; paginate(); };

  // ── Filtres ───────────────────────────────────────────────────────────────
  function applyFilters() {
    var q = ($scope.searchQuery  || '').toLowerCase().trim();
    var t = ($scope.filterType   || '').trim();
    var s = ($scope.filterStatut || '').trim();
    allList = rawList.filter(function(a) {
      var matchQ = !q || [a.societe || '', a.numeroAutorisation || '', a.substance || '']
        .some(function(f) { return f.toLowerCase().indexOf(q) !== -1; });
      var matchT = !t || a.typeAutorisation === t;
      var matchS = !s || a.statut === s;
      return matchQ && matchT && matchS;
    });
    $scope.totalItems  = allList.length;
    $scope.currentPage = 1;
    paginate();
  }

  var searchTimeout;

  function flash(type, msg) {
    $scope[type] = msg;
    $timeout(function() { $scope[type] = ''; }, 3500);
  }

  // ── Chargement ────────────────────────────────────────────────────────────
  $scope.load = function() {
    $scope.isLoading = true;
    $http.get(API)
      .then(function(res) {
        rawList = Array.isArray(res.data) ? res.data : (res.data.content || []);
        applyFilters();
      })
      .catch(function() { flash('errorMsg', 'Erreur lors du chargement des autorisations minières.'); })
      .finally(function() { $scope.isLoading = false; });
  };

  $scope.onSearch = function() {
    if (searchTimeout) $timeout.cancel(searchTimeout);
    searchTimeout = $timeout(function() { applyFilters(); }, 300);
  };

  $scope.onFilterChange = function() { applyFilters(); };

  $scope.setPage = function(p) {
    if (p < 1 || p > $scope.totalPages) return;
    $scope.currentPage = p; paginate();
  };

  $scope.getPages = function() {
    var pages = [], s = Math.max(1, $scope.currentPage - 2), e = Math.min($scope.totalPages, $scope.currentPage + 2);
    for (var i = s; i <= e; i++) pages.push(i);
    return pages;
  };

  // ── Formatage ─────────────────────────────────────────────────────────────
  $scope.formatDate = function(date) {
    if (!date) return '—';
    var d, day, month, year;
    if (Array.isArray(date)) {
      year = date[0]; month = date[1]; day = date[2];
    } else {
      d = new Date(date);
      if (isNaN(d.getTime())) return '—';
      day = d.getDate(); month = d.getMonth() + 1; year = d.getFullYear();
    }
    return (day < 10 ? '0' + day : '' + day) + '/' +
           (month < 10 ? '0' + month : '' + month) + '/' + year;
  };

  function toDateStr(date) {
    if (!date) return '';
    if (Array.isArray(date)) {
      var m = date[1] < 10 ? '0' + date[1] : '' + date[1];
      var d = date[2] < 10 ? '0' + date[2] : '' + date[2];
      return date[0] + '-' + m + '-' + d;
    }
    return date.substring(0, 10);
  }

  // ── Modal ─────────────────────────────────────────────────────────────────
  $scope.openModal = function(a) {
    if (a) {
      $scope.editingItem = angular.copy(a);
      $scope.editingItem.dateAttributionStr = toDateStr(a.dateAttribution);
      $scope.editingItem.dateExpirationStr  = toDateStr(a.dateExpiration);
    } else {
      $scope.editingItem = { statut: 'En vigueur', dateAttributionStr: '', dateExpirationStr: '' };
    }
    $scope.showModal = true;
  };

  $scope.closeModal = function() { $scope.showModal = false; $scope.editingItem = {}; };

  // ── Sauvegarde ────────────────────────────────────────────────────────────
  $scope.save = function() {
    if (!$scope.editingItem.societe) { flash('errorMsg', 'La société est obligatoire.'); return; }
    $scope.saving = true;
    var payload = angular.copy($scope.editingItem);
    payload.dateAttribution = payload.dateAttributionStr || null;
    payload.dateExpiration  = payload.dateExpirationStr  || null;
    delete payload.dateAttributionStr;
    delete payload.dateExpirationStr;

    var isEdit = !!payload.id;
    var req = isEdit ? $http.put(API + '/' + payload.id, payload) : $http.post(API, payload);
    req.then(function() {
      $scope.closeModal(); $scope.load();
      flash('successMsg', isEdit ? 'Autorisation mise à jour.' : 'Autorisation créée.');
    })
    .catch(function(err) {
      flash('errorMsg', (err.data && typeof err.data === 'string') ? err.data : 'Erreur lors de l\'enregistrement.');
    })
    .finally(function() { $scope.saving = false; });
  };

  // ── Suppression ───────────────────────────────────────────────────────────
  $scope.delete = function(a) {
    if (!confirm('Supprimer l\'autorisation de "' + a.societe + '" ?')) return;
    $http.delete(API + '/' + a.id)
      .then(function() { $scope.load(); flash('successMsg', 'Autorisation supprimée.'); })
      .catch(function() { flash('errorMsg', 'Erreur lors de la suppression.'); });
  };

  // ── Export ────────────────────────────────────────────────────────────────
  $scope.showExportMenu = false;
  $scope.toggleExportMenu = function($event) { $event.stopPropagation(); $scope.showExportMenu = !$scope.showExportMenu; };
  var _hideMenu = function() { $scope.$applyAsync(function() { $scope.showExportMenu = false; $scope.showColPicker = false; }); };
  document.addEventListener('click', _hideMenu);
  $scope.$on('$destroy', function() { document.removeEventListener('click', _hideMenu); });

  $scope.showColPicker = false;
  $scope.toggleColPicker = function($event) { $event.stopPropagation(); $scope.showColPicker = !$scope.showColPicker; $scope.showExportMenu = false; };
  $scope.col = { numero: true, type: true, substance: true, region: true, expiration: true, statut: true };
  var COL_DEFS = [
    { key: 'societe',    label: 'Société',           fn: function(a){ return a.societe||''; } },
    { key: 'numero',     label: 'N° autorisation',   fn: function(a){ return a.numeroAutorisation||''; } },
    { key: 'type',       label: 'Type',              fn: function(a){ return a.typeAutorisation||''; } },
    { key: 'substance',  label: 'Substance',         fn: function(a){ return a.substance||''; } },
    { key: 'region',     label: 'Région',            fn: function(a){ return a.region||''; } },
    { key: 'expiration', label: 'Date d\'expiration', fn: function(a){ return $scope.formatDate(a.dateExpiration); } },
    { key: 'statut',     label: 'Statut',            fn: function(a){ return a.statut||''; } }
  ];
  function visibleDefs() { return COL_DEFS.filter(function(d){ return d.key === 'societe' || $scope.col[d.key]; }); }
  function getExportRows() {
    var defs = visibleDefs();
    return allList.map(function(a) { return defs.map(function(d){ return d.fn(a); }); });
  }
  function getExportHeaders() { return visibleDefs().map(function(d){ return d.label; }); }
  function escHtml(s) { return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
  function triggerDl(blob, name) {
    var url = URL.createObjectURL(blob), a = document.createElement('a');
    a.href = url; a.download = name; document.body.appendChild(a); a.click(); document.body.removeChild(a);
    $timeout(function() { URL.revokeObjectURL(url); }, 500);
  }
  $scope.exportCSV = function() {
    $scope.showExportMenu = false;
    var rows = getExportRows().map(function(r) { return r.map(function(v) { return '"'+String(v).replace(/"/g,'""')+'"'; }).join(';'); });
    triggerDl(new Blob(['\uFEFF'+getExportHeaders().join(';')+'\n'+rows.join('\n')], {type:'text/csv;charset=utf-8;'}), 'autorisations-minieres.csv');
  };
  $scope.exportExcel = function() {
    $scope.showExportMenu = false;
    var cell='border:1px solid #b0bec5;padding:6px 10px;font-size:11pt;font-family:Calibri,Arial,sans-serif;vertical-align:middle;', rows=getExportRows(), hdrs=getExportHeaders();
    var html='<html><head><meta charset="utf-8"/></head><body><table style="border-collapse:collapse">';
    html+='<tr><td colspan="'+hdrs.length+'" style="'+cell+'background:#0f2544;color:#fff;font-size:14pt;font-weight:bold;text-align:center;padding:12px;">Autorisations Minières</td></tr>';
    html+='<tr><td colspan="'+hdrs.length+'" style="'+cell+'background:#e8edf5;color:#555;font-size:9pt;text-align:center;">Exporté le '+new Date().toLocaleDateString('fr-FR')+' — '+rows.length+' entrée(s)</td></tr>';
    html+='<tr>'+hdrs.map(function(h){return'<th style="'+cell+'background:#1e3a5f;color:#fff;font-weight:bold;">'+h+'</th>';}).join('')+'</tr>';
    rows.forEach(function(r,i){var bg=i%2===0?'#f0f4fa':'#fff';html+='<tr>'+r.map(function(v){return'<td style="'+cell+'background:'+bg+';">'+escHtml(v)+'</td>';}).join('')+'</tr>';});
    html+='</table></body></html>';
    triggerDl(new Blob(['\uFEFF'+html],{type:'application/vnd.ms-excel;charset=utf-8;'}), 'autorisations-minieres.xls');
  };

  $scope.load();
}]);
